<template>
    <div class="pageDiv">
        <div class="loader" v-if="$CommandSvc.isBusy()"></div>
        <v-card class="main-card">
            <div class="make-logo-div">
                <div style="margin-top:20px;margin-left:30px;">
                    <img src="../assets/img/dfwvga-logo-mini.png"
                         style="display:inline-block;position:relative;width:100px;border-radius:50%;">
                    <span class="dfwvga-name">Dallas-Ft Worth Vietnamese Golf Association</span>
                </div>
            </div>

            <v-card-text class="sponsor"  v-if="tournament !== null && tournament.tournament.status === 'REGISTER'">
                <div class="div100 etch-out">
                    <v-card-text v-if="sponsor !== null && sponsor.sponsorName !== null && sponsor.sponsorName !== ''">
                        Thank you <span class="label14">{{sponsor.sponsorName}}</span> for being our sponsor in the upcoming
                        tournament at <span class="label14">{{sponsor.tournamentName}}</span> on
                        <span class="label14">{{sponsor.tournamentDate}}</span>. The
                        DFWVGA club appreciate your generosity and kindness for being our sponsor.
                    </v-card-text>

                    <v-card-text>
                        <br>
                        <a v-if="tournament !== null && tournament.tournament.formatType === 'TOURNAMENT'" class="label14" @click="gotoTournament(tournament.tournament.tournamentId)">
                            REGISTER TOURNAMENT @ {{tournament !== null ? tournament.course.name : ""}}
                        </a>
                        <br><br>

                        <v-card-text class="div60">
                            <div class="loader" v-if="$CommandSvc.isBusy()"></div>
                            <img class="sponsor-img" :src="$AuthSvc.getFlyerUrl()" >
                        </v-card-text>
                    </v-card-text>
                </div>
            </v-card-text>

            <v-card-text v-for="event in events" :key="event.eventName" style="padding:0">
                <v-card-text class="div100 etch-out">
                    <span class="actionBtn" @click="remove(event.clubEventId)" v-if="$AuthSvc.isAdmin()">
                        <v-icon>mdi-delete</v-icon>
                    </span>
                    <span class="actionBtn" @click="edit(event.clubEventId)" v-if="$AuthSvc.isAdmin()">
                        <v-icon>mdi-pencil</v-icon>
                    </span>

                    <v-card-title>
                        <span class="label14">{{event.title}}</span>
                    </v-card-title>
                    <div class="messageDiv">
                        <div v-if="event.formatType === 'HTML'">
                            <span v-html="event.message"></span>
                        </div>

                        <div v-if="event.formatType === 'TEXT'">
                            <pre>{{event.message}}</pre>
                        </div>
                    </div>
                </v-card-text>
            </v-card-text>

            <v-card-text class="messageCard" style="display:none">
                <v-img class="chucMungDiv" :src="require(`../assets/img/chuc-mung-2025.png`)">
                </v-img>
                Welcome to DFWVGA 2026 golf season, as we embark up another year of golf and friendship, it is a great honor for our committee to represent the club and you, the members, in 2026. We are looking forward to carrying on the positive work of our entire previous trail blazer.
                Of course, many thank you to our sponsors for your ongoing support and outstanding contribution to our organization.
                <br>
                We are looking forward to see you all at our tournament and enjoy events throughout the year. We are wishing you and your families, a happy, healthy and successful 2026!!!
                <br><br>

                <span class="label14">We are also pleased to share the following:</span>

                <br><br>
                <span class="label16">TEXAS CUP IS BACK!!!</span>
                <ul class="ulSquare">
                    <li>We are hosting 2026 Texas Cup. Thank you our captain Quan Nguyen, he has been working hard with
                        HVGA to bring back Texas Cup.</li>
                    <li>40 players per team</li>
                    <li>Please check our website for rules and qualification</li>
                </ul>

                <br>
                <span class="label16">LAO Cup</span>
                <ul class="ulSquare">
                    <li>Thank you captain Phy Pham for volunteering to lead our team.</li>
                    <li>Both clubs will continue this traditional fun match play for our members.</li>
                    <li>24 players per team</li>
                    <li>Please check our website for rules and qualification</li>
                </ul>

                <br>
                <span class="label16">NEW Red River Rilvary Cup!!!</span>
                <ul class="ulSquare">
                    <li>To our friends in Oklahoma City, OKAGA Golf Association. Congratulations on the formation of your
                        new golf club! Wishing you a successful journey ahead, filled with positive impact and meaningful
                        collaborations. We are excited to begin our annual Ryder cup challenge between DFWVGA and OKAGA.</li>
                    <li>24 players per team</li>
                    <li>Thank you captain Quan Nguyen for volunteering to lead our team.</li>
                    <li>Please check our website for rules and qualification</li>
                </ul>

                <br>
                <span class="label16">Tournament</span>
                <ul class="ulSquare">
                    <li>We will have 7 tournaments earning points for Cups match play.</li>
                    <li>DFWVGA club Championship point’s system FEDEX point. Points are based on how a player finished in each tournament. Please see on our website under Cup Rules for updated rules and a more detailed breakdown of the point system. This is the same as last year.</li>
                    <li>NICKLAUS, PALMER, and HOGAN. All women and junior girls will be placed in respective flights based on their handicap and will be able to play from the RED tee box. They will be able to participate and win Club CHAMP in the respective flights, but will NOT be qualified to play in any DFWVGA Cup unless they choose to play in the BLUE tees during tournaments. Only players that play from BLUE tee box are qualified for any of the DFWVGA Cups. Also, there is no change here from last year.</li>
                </ul>

                <br>
                <span class="label16">Membership Fees</span>
                <ul class="ulSquare">
                    <li>The membership fees for this year will be $120 per member.</li>
                    <li>Junior associate membership is free for age 17 and under, who parent is a current member of DFWVGA
                        club.</li>
                </ul>

                <br>
                <span class="label16">Payment (New account)</span>
                <ul class="ulSquare">
                    <li>Zelle account <span class="label14">pay@dfwvga.com</span></li>
                    <li>Check payable to <span class="label14">DFWVGA</span></li>
                </ul>

                <br>
                <span class="label16">Club email (New account)</span>
                <ul class="ulSquare">
                    <li><a class="footer-icon" href="mailto: dfwvga.info@dfwvga.com">
                        dfwvga.info@dfwvga.com
                    </a></li>
                </ul>

                <br><br>

                Please send your feedback and suggestion to

                <a class="footer-icon" href="mailto: dfwvga.info@dfwvga.com">
                    dfwvga.info@dfwvga.com
                </a>

                <br><br>
                <span class="label16">DFWVGA club</span>
                <span class="label16"></span>
                <ul class="ulSquare">
                    <li>Bao Nguyen</li>
                    <li>Binh Hoang</li>
                    <li>Quan Nguyen</li>
                    <li>Vincent Tran</li>
                    <li>Vincent Vothang</li>
                </ul>

            </v-card-text>

            <v-card-text class="sponsor" style="display:none">
                <div class="sponsor-text">
                    <v-card-text style="width:100%;">
                        It is time for our annual banquet! You can now register for the 2024 Annual Banquet now.
                        Please register as soon as possible.
                        The venue is at  <span class="label14">ABC Restaurant in Arlington</span> on
                        <span class="label14">Saturday October 12, 2024 @ 7pm</span>. The
                        DFWVGA club appreciate banquet sponsors.
                    </v-card-text>

                    <v-card-text v-if="$AuthSvc.isLogin()">
                        <br>
                            <a v-if="tournament !== null && tournament.tournament.formatType === 'TOURNAMENT'" class="label16" @click="gotoTournament(33)">
                                Register for 2024 Banquet
                            </a>
                        <br><br>
                    </v-card-text>

                    <v-card-text class="sponsor-img-div">
                        <v-img class="sponsor-img" :src="'/imagers/courses/dfwvga-banquet-2.png'">
                        </v-img>
                    </v-card-text>
                </div>
            </v-card-text>

            <v-card-text class="sponsor" style="display:none">
                <v-card-text style="width:100%;">
                    <span class="label18">Congratulations DFWVGA as winners of the DFWVGA vs DFWLGA cup.</span>
                    <br><br>
                    <span class="label14">See Results:</span>
                </v-card-text>

                <v-card-text>
                    <a href="/results?id=53">
                        <span class="label16">DFWVGA vs. LAOS (AM - SCRAMBLE)</span>
                    </a>
                    <br>
                    <a href="/results?id=56">
                        <span class="label16">DFWVGA vs. LAOS (PM - BEST BALL)</span>
                    </a>
                    <br><br>
                </v-card-text>

                <v-card-text class="sponsor-img-div">
                    <v-img class="sponsor-img" :src="require(`../assets/img/dfwvga_lao.png`)">
                    </v-img>
                </v-card-text>
            </v-card-text>

            <br><br>

            <v-card-text style="font-size:14px;">
                To enroll, click here. <a href="https://www.dfwvga.com/enroll">https://www.dfwvga.com/enroll</a>
            </v-card-text>

        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "home",
    data: () => ({
      loading: true,
      dfwvgaConfig: {"sponsorName": "", "tournamentName": "", "tournamentDate": ""},
      events: [],
      registerTournaments: [],
      tournament: null,
      sponsor: null
    }),
    mounted: function() {
       var _this = this;
       _this.$CommandSvc.get(_this, '/public/config/current-sponsor',
        function (data) {
           if (data !== '') {
              _this.sponsor = data;
           }
        },
        function (error) {
            console.log('ERROR: ' + error);
        });

       this.loadData();
    },
    methods: {
      loadData() {
        var _this = this;
        _this.$CommandSvc.get(_this, '/public/club-events',
            function (data) {
                _this.events = data;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });

        _this.$CommandSvc.get(_this, '/public/config',
            function (response) {
                _this.dfwvgaConfig = response.data;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });

        _this.$CommandSvc.get(_this, '/public/tournaments/status/APPROVALS', function(response) {
          _this.registerTournaments = response.data;
          if (_this.registerTournaments.length > 0 ) {
            _this.tournament = _this.registerTournaments[0];
          }
        });
      },
      hasSponsor() {
        return (this.sponsor !== null && this.sponsor.showSponsor === 'Y');
      },
      onChange() {
        console.log("Message Type: ", this.messageType);
      },
      edit(clubEventId) {
        window.location.href = '/home-admin?id=' + clubEventId;
      },
      printTime(date) {
        return moment(date).format('ddd MMMM DD YYYY hh:mm A');
      },
      remove(id) {
        var _this = this;

        swal({
          title: "Are you sure?",
          text: "Delete this message",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            _this.axios.delete('/admin/club-events/'+id)
            .then(function (response) {
                console.log('Item DELETED ' + response.data);
                _this.loadData();
            });
          }
        });
      },
      gotoTournament(tournamentId) {
        window.location.href = "/registration?id=" + tournamentId;
      }
    },
    handleFileUpload( event ){
        this.file = event.target.files[0];
    }
  }
</script>

<style scoped>


    .main-card {
        background-color: white !important;
    }

    .make-logo-div {
        display: none;
        width: 100%;
        background-image: url("../assets/img/cowboys-header.png");
        background-size: cover;
        background-color: #0f0e0f;
    }

    .dfwvga-name{
        display: inline-block;
        font-size: 40px;
        font-weight: bold;
        color: gold;
        height: 200px;
        vertical-align: top;
        padding-top: 25px;
        padding-left: 7px;
    }

      ul {
        list-style: square;
      }

      li {
          margin-left: 30px;
      }

      .events-card {
          margin: 3px 0 !important;
          padding: 3px !important;
      }

      .event-card {
          padding: 3px !important;
      }

      .winner-table {
          width: 100%;
      }

      .sponsor {
          margin: 5px 0;
      }

      .sponsor .sponsor-text {
          display: inline-block;
          vertical-align: top;
          padding: 5px 0;
          width: 100%;
      }

      .sponsor-text * {
          font-size: 14px;
      }

      .sponsor .image {
          padding: 5px;
      }

      .sponsor-img {
         width: 100%;
         border-radius: 10px;
      }

      img {
        width: 100%;
      }

      .chucMungDiv {
          display: none;
          width: 100%;
          margin-bottom: 15px;
          border-radius: 12px;
      }

      .messageCard {
          font-size: 14px !important;
      }

      @media (min-width: 768px) {

          .sponsor .sponsor-text {
              display: inline-block;
              vertical-align: top;
              padding: 25px;
          }

          .sponsor .image {
              display: inline-block;
              width: 45% !important;
              padding: 25px;
          }

          .sponsor-img {
             width: 65%;
             border-radius: 10px;
          }

          .winner-table {
              width: 49%;
          }

          .image-card {
              width: 45% !important;
              margin: 10px;
              border-radius: 10px;
          }

        img {
          width: 600px;
        }

        .chucMungDiv {
          padding: 10px;
          width: 70%;
        }
      }

      th {
          text-align: left;
          height: 28px;
          background-color: darkseagreen;
          border:1px solid rgba(0,0,0,0.4);
          box-shadow:1px 1px 1px -1px #000;
      }

      th, td {
          padding: 5px 10px;
      }

      td {
          border:1px solid rgba(0,0,0,0.4);
          box-shadow:-1px -1px 1px -1px #000;
          background-color: aquamarine;
      }

      pre {
          line-height: 1.5;
      }

      .actionBtn {
          display: inline-block;
          float: right;
          margin-left: 7px;
      }

      .actionBtn .v-icon {
          font-size: 18px !important;
      }

      .actionBtn:hover {
          cursor: pointer;
      }
</style>